import React from 'react';

import { useStorageBookingFunnelAssignment } from '@utils/hooks/storage_booking_funnel_test';

import { ChallengerStoragePlanPage } from './challenger/storage_plan_page';
import { ClassicStorageProductPage } from './classic_storage_product_page';

/** Used by classic scroll helpers (cart / edit navigation). */
export const STICKY_CONTENT_CONTAINER_HEIGHT = 564;

/**
 * Storage booking funnel entry (`/book/storage`).
 * Classic (control) vs challenger UI is selected by Abeet
 * `web_visitor_storage_booking_funnel` (or `?force_booking_funnel=`).
 */
export const StorageProductPage = () => {
  const { isChallenger, isReady } = useStorageBookingFunnelAssignment();

  // Avoid flashing the classic funnel while Abeet resolves after SPA navigation.
  if (!isReady) return null;

  return isChallenger ? (
    <ChallengerStoragePlanPage />
  ) : (
    <ClassicStorageProductPage />
  );
};
